module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAiYAAAFvAgMAAAADH+jsAAAACVBMVEXYHgXysqr///8HgDpKAAAAk0lEQVR42u3cQREAIAwDwUrkg7++UYmNZGZXwSm4AQAAAAAAAAAAAAAAAAAAAKDZTXHmpVgpUqRIkSJFihQpUqRIkSJFihQpUqRIkSJFihQpUqRIkSJFihQpUqRIkSJFihQpUqRIkSJFihQpUqRIkSJFihQpUqRIkSJFipSWlKR7BAAAAAAAAAAAAAAAAAAAAADFPmNfqepfiLDmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/flag/at.png
// module id = jOBu
// module chunks = 0